import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Check } from 'react-feather';

const Checkbox = ({
    id,
    name,
    className,
    handleChange,
    isSelected,
    checkBoxLabel,
    hideLabel,
    checkBoxDisable,
    isError,
    labelPosition,
    labelClassName,
    register = () => { },
    height,
    width,
    errorMessage,
    checkClassName,
    checkIconClass,
    checkBoxContainerClassName,
    onKeyDown,
    isDisabled,
    hoverMessage,
    labelStyle = {}
}) => {
    const containerClassNames = classnames(
        'flex items-center cursor-pointer relative',
        labelPosition === 'left' && 'flex-row-reverse',
        checkBoxDisable && 'pointer-events-none',
        isDisabled && '!cursor-not-allowed',
        className,
        checkBoxContainerClassName
    );
    const handleKeyDown = (event) => {
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();

            handleChange?.({ target: { name, checked: !isSelected } });
        }
        if (onKeyDown) onKeyDown(event);
    };
    return (
        <>
            <label className={containerClassNames}>
                <span
                    className={classnames(
                        'flex justify-center items-center relative rounded border border-gray-400 focus-within:!border-primary-300',
                        isSelected && 'bg-primary-300 border-primary-300',
                        isDisabled && 'bg-gray-600 cursor-not-allowed !border-gray-600',
                        checkClassName,
                        `w-${width || '4'} h-${height || '4'}`)}
                >
                    <input
                        id={id}
                        name={name}
                        onChange={handleChange}
                        type="checkbox"
                        checked={isSelected}
                        {...register(name)}
                        className={`absolute inset-0 w-full h-full opacity-0 cursor-pointer ${className}`}
                        disabled={isDisabled}
                        onKeyDown={handleKeyDown}
                    />
                    {isSelected && <Check className={checkIconClass} size={16} />}
                </span>

                {!hideLabel && (
                    <span
                        style={labelStyle}
                        className={`text-sm text-gray-100 select-none ${labelClassName} ${labelPosition === 'left' ? 'mr-2' : 'ml-2'}`}>
                        {checkBoxLabel}
                    </span>
                )}
            </label>
            {isError && <div className="block text-xs text-error-300 mt-1">{errorMessage}</div>}
        </>
    );
};

Checkbox.defaultProps = {
    labelPosition: 'right'
};

Checkbox.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    handleChange: PropTypes.func,
    isSelected: PropTypes.bool,
    isError: PropTypes.bool,
    value: PropTypes.string,
    hideLabel: PropTypes.bool,
    checkBoxDisable: PropTypes.bool,
    labelPosition: PropTypes.oneOf(['left', 'right']),
    labelClassName: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    errorMessage: PropTypes.string
};

export default Checkbox;
